var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('OrdersCount',{attrs:{"total":_vm.data.incidents,"open":_vm.data.incidents_open}},[_vm._v("M#"+_vm._s(_vm.getAccount()))])}
var staticRenderFns = []

export { render, staticRenderFns }